import React from "react";
import styled from "styled-components";
import {
  LandingHero,
  AboutSection,
  OfferSection,
  Services,
  Gallery,
  Info,
  Intro,
  ContactUS,
  AdmissionSection,
  Testimonials,
  Special,
} from "../components/landing";
import { Helmet } from "react-helmet";
import ContactUs from "../components/landing/contactSection";
import News from "../components/landing/newsSection";
import WatchVideo from "../components/landing/videoSection/video";

export default function Home() {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "EducationalOrganization",
    name: "Firdaus-Gate Model Schools",
    description:
      "Islamic model school offering quality education with faith-based values",
    url: "https://www.firdaus-gate.com",
    logo: "https://www.firdaus-gate.com/favicon.ico",
    address: {
      "@type": "PostalAddress",
      streetAddress: "6/8 Balogun Street, off Igodo Road, Omo-Olope Area",
      addressLocality: "Magboro",
      addressRegion: "Ogun State",
      addressCountry: "NG",
    },
    founder: {
      "@type": "Person",
      name: "Mr Wahab",
    },
  };

  return (
    <Wrapper className=" ">
      <Helmet>
        <title>
          Firdaus-Gate Model Schools | Quality Islamic Education in Magboro
        </title>
        <meta
          name="description"
          content="Welcome to Firdaus-Gate Model Schools, where knowledge meets faith. We offer comprehensive Islamic education with academic excellence, government-approved curriculum, and modern facilities in Magboro, Ogun State."
        />
        <meta
          property="og:title"
          content="Firdaus-Gate Model Schools | Quality Islamic Education"
        />
        <meta
          property="og:description"
          content="Where knowledge meets faith. Nurturing minds, hearts, and character through excellent academic programs and Islamic values since 2012."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.firdaus-gate.com" />
        <meta
          property="og:image"
          content="https://www.firdaus-gate.com/favicon.ico"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Firdaus-Gate Model Schools | Quality Islamic Education"
        />
        <meta
          name="twitter:description"
          content="Where knowledge meets faith. Nurturing minds, hearts, and character through excellent academic programs and Islamic values."
        />
        <link rel="canonical" href="https://www.firdaus-gate.com" />
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>
      <LandingHero />
      <AboutSection />
      <Intro />
      <OfferSection />
      <Gallery />
      <Special />
      <Info />
      <WatchVideo />
      <Testimonials />
      <AdmissionSection />
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100vw;
  overflow-x: hidden !important;
  height: fit-content !important;
  p {
    font-size: 16px !important;
    font-weight: 400 !important;
    /* color: black !important; */
  }
  @media (max-width: 768px) {
    p {
      font-size: 16px !important;
    }
  }
  h2 {
    @media screen and (min-width: 599px) and (max-width: 899px) {
      font-size: 40px !important;
    }
    @media screen and (max-width: 599px) {
      font-size: 32px !important;
    }
  }
`;
